import React, { useMemo } from 'react';
import './Avatar.css';

const colorCache = {};

const hashString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
        hash = (hash * 31 + str.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
};

const generatePastelColor = (name) => {
    if (colorCache[name]) {
        return colorCache[name];
    }

    const hue = hashString(name) % 360;
    const saturation = 55 + (hashString(name + 's') % 15);
    const lightness = 70 + (hashString(name + 'l') % 10);
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    colorCache[name] = color;
    return color;
};

const getInitials = (name) => {
    if (!name) {
        return '';
    }

    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }

    return name.trim().substring(0, 2).toUpperCase();
};

export const Avatar = ({ name, size = 36, className = '', ...props }) => {
    const initials = useMemo(() => getInitials(name), [name]);
    const backgroundColor = useMemo(() => generatePastelColor(name), [name]);

    return (
        <span
            className={`avatar ${className}`}
            style={{
                width: size,
                height: size,
                backgroundColor,
                fontSize: Math.max(12, Math.round(size * 0.42)),
            }}
            aria-hidden="true"
            data-testid={props['data-testid'] || 'avatar'}
            {...props}
        >
            {initials}
        </span>
    );
};

export default Avatar;
